import { Sizes, Weights } from '@/common/types';
import { styled } from '@/stitches.config';

export const StyledNumber = styled('span', {
  color: '$darkBlue300',
  textAlign: 'left',
  lineHeight: 'normal',
  variants: {
    size: {
      [Sizes.SMALL]: {
        fontSize: '$studyInsights$fontXs',
      },
      [Sizes.MEDIUM]: {
        fontSize: '$studyInsights$fontMd',
      },
      [Sizes.LARGE]: {
        fontSize: '$studyInsights$fontXl',
      },
      [Sizes.EXTRA_LARGE]: {
        fontSize: '$studyInsights$fontXxl',
      },
    },
    weight: {
      [Weights.REGULAR]: {
        fontWeight: '$regular',
      },
      [Weights.MEDIUM]: {
        fontWeight: '$medium',
      },
      [Weights.BOLD]: {
        fontWeight: '$bold',
      },
      [Weights.EXTRA_BOLD]: {
        fontWeight: '$xbold',
      },
    },
  },
});
